(function () {
  'use strict';

  function initProductReviewRating() {
    const widget = document.querySelector('#judgeme_product_reviews');

    if (!widget) {
      return;
    }

    const ratingDisplay = widget.querySelector('.jm-average-rating-display');

    if (!ratingDisplay) {
      return;
    }

    /*
     * Judge.me updates this value automatically.
     * Example:
     * data-shop-average-rating="4.85"
     */
    const rating = parseFloat(widget.dataset.shopAverageRating);

    if (Number.isNaN(rating)) {
      return;
    }

    /*
     * Don't insert the stars twice when Judge.me re-renders.
     */
    const oldStars = ratingDisplay.querySelector(
      '.product-review-rating-stars'
    );

    if (oldStars) {
      oldStars.remove();
    }

    const stars = document.createElement('div');

    stars.className = 'product-review-rating-stars';
    stars.setAttribute('aria-hidden', 'true');

    /*
     * Figma contains:
     * full star
     * half star
     * empty star
     *
     * We round to the nearest half:
     *
     * 4.00 - 4.24 => 4.0
     * 4.25 - 4.74 => 4.5
     * 4.75 - 5.00 => 5.0
     */
    const roundedRating = Math.round(rating * 2) / 2;

    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('span');

      star.className = 'product-review-rating-star';

      if (roundedRating >= i) {
        star.classList.add('product-review-rating-star--full');
      } else if (roundedRating >= i - 0.5) {
        star.classList.add('product-review-rating-star--half');
      } else {
        star.classList.add('product-review-rating-star--empty');
      }

      stars.appendChild(star);
    }

    /*
     * Put stars before Judge.me review count.
     */
    ratingDisplay.prepend(stars);
  }

  function initProductTopRating() {
    const widget = document.querySelector('#judgeme_product_reviews');
    const summary = document.querySelector('[data-product-review-summary]');

    if (!widget || !summary) {
      return;
    }

    const starsContainer = summary.querySelector(
      '[data-product-review-stars]'
    );

    const countContainer = summary.querySelector(
      '[data-product-review-count]'
    );

    if (!starsContainer || !countContainer) {
      return;
    }

    const productId = widget.dataset.productId;

    let rating = 0;
    let reviewCount = 0;

    /*
    * Основне джерело — Judge.me data object.
    * Воно працює і коли відгуків 0.
    */
    if (
      window.jdgm &&
      window.jdgm.data &&
      window.jdgm.data.reviewWidget &&
      productId &&
      window.jdgm.data.reviewWidget[productId]
    ) {
      const reviewData = window.jdgm.data.reviewWidget[productId];

      rating = parseFloat(reviewData.average_rating) || 0;
      reviewCount = parseInt(reviewData.number_of_reviews, 10) || 0;
    } else {
      /*
      * Fallback для звичайного стану Judge.me.
      */
      rating = parseFloat(widget.dataset.shopAverageRating) || 0;

      const judgeCount = widget.querySelector(
        '.jm-average-rating-display .jm-text:nth-of-type(2)'
      );

      if (judgeCount) {
        reviewCount =
          parseInt(judgeCount.textContent.replace(/\D/g, ''), 10) || 0;
      }
    }

    const roundedRating = Math.round(rating * 2) / 2;

    starsContainer.innerHTML = '';

    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('span');

      star.className = 'product-redesign__rating-star';

      if (roundedRating >= i) {
        star.classList.add(
          'product-redesign__rating-star--full'
        );
      } else if (roundedRating >= i - 0.5) {
        star.classList.add(
          'product-redesign__rating-star--half'
        );
      } else {
        star.classList.add(
          'product-redesign__rating-star--empty'
        );
      }

      starsContainer.appendChild(star);
    }

    countContainer.textContent =
      reviewCount === 1
        ? '1 Review'
        : reviewCount + ' Reviews';

    summary.setAttribute(
      'aria-label',
      rating + ' out of 5. ' +
      reviewCount +
      (reviewCount === 1 ? ' review' : ' reviews')
    );

    summary.hidden = false;
  }

  function initJudgeMeProductReviews() {
    initProductReviewRating();
    initProductTopRating();

    const widget = document.querySelector('#judgeme_product_reviews');

    if (!widget) {
      return;
    }

    /*
     * Judge.me is Vue-based and re-renders parts of the widget
     * after pagination/filtering.
     *
     * Re-create our header stars after such updates.
     */
    let updateTimer = null;

    const observer = new MutationObserver(function () {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(function () {
        const ratingDisplay = widget.querySelector(
          '.jm-average-rating-display'
        );

        if (
          ratingDisplay &&
          !ratingDisplay.querySelector('.product-review-rating-stars')
        ) {
          initProductReviewRating();
        }

        initProductTopRating();
      }, 50);
    });

    observer.observe(widget, {
      childList: true,
      subtree: true
    });
  }


  /*
   * Judge.me may render after DOMContentLoaded,
   * so wait until its widget appears.
   */
  function waitForJudgeMe() {
    const widget = document.querySelector('#judgeme_product_reviews');

    if (widget) {
      initJudgeMeProductReviews();
      return;
    }

    const observer = new MutationObserver(function (_, observerInstance) {
      const widget = document.querySelector('#judgeme_product_reviews');

      if (widget) {
        observerInstance.disconnect();
        initJudgeMeProductReviews();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForJudgeMe);
  } else {
    waitForJudgeMe();
  }
})();